module.exports = __webpack_public_path__ + "img/icon_member.ba6804cb.svg";